import { CONNECTOR_TYPES } from '../../../../policyholders/connectors/connectors.constants';
import { ServiceHandler, type ServiceConfig } from '../../../../utils';

export enum ActionType {
  API_ENDPOINT = 'API Endpoint',
  CLOSE_MODAL = 'Close Modal',
  GO_FORWARD = 'Go Forward',
}

interface ActionProps {
  type: ActionType;
  requestConfig: ServiceConfig;
}

export const handleAction = (action: ActionProps, payload: any) => {
  const { requestConfig } = action;

  return ServiceHandler(requestConfig)(payload);
};

export const transformPayloadForConnector = (
  connectorType: string,
  payload: any
) => {
  if (connectorType === CONNECTOR_TYPES.GOOGLEWORKSPACE) {
    return transformPayloadForGoogleWorkspace(payload);
  }
  if (connectorType === CONNECTOR_TYPES.GEMINI) {
    return transformPayloadForGemini(payload);
  }
  if (connectorType === CONNECTOR_TYPES.GSC) {
    return transformPayloadForGSC(payload);
  }
  if (connectorType === CONNECTOR_TYPES.CLOUDFLARE) {
    return transformPayloadForCloudflare(payload);
  }
  if (connectorType === CONNECTOR_TYPES.SOPHOS) {
    return transformPayloadForSophos(payload);
  }
  if (connectorType === CONNECTOR_TYPES.LANGFUSE) {
    return transformPayloadForLangfuse(payload);
  }
  if (connectorType === CONNECTOR_TYPES.CLAUDE) {
    return transformPayloadForClaude(payload);
  }
  return payload;
};

const transformPayloadForGoogleWorkspace = (payload: any) => {
  const { cbid, formValues } = payload;
  const { accountEmail } = formValues;

  const formData = new FormData();
  if (formValues?.credentials) {
    formData.append('credentials', formValues.credentials[0]);
  }

  return {
    data: formData,
    params: { cbid, accountEmail },
  };
};

export const transformPayloadForGemini = (payload: any) => {
  const { cbid, formValues } = payload;
  const adminEmail = formValues?.adminEmail?.trim();
  const customerId = formValues?.customerId?.trim();

  const formData = new FormData();
  if (formValues?.credentials) {
    formData.append('credentials', formValues.credentials[0]);
  }
  formData.append(
    'params',
    new Blob(
      [JSON.stringify({ cbid, adminEmail, ...(customerId && { customerId }) })],
      { type: 'application/json' }
    )
  );

  return { data: formData };
};

const transformPayloadForGSC = (payload: any) => {
  const { cbid, formValues } = payload;
  const { orgId } = formValues;

  const formData = new FormData();
  if (formValues?.credentials) {
    formData.append('credentials', formValues.credentials[0]);
  }

  return {
    data: formData,
    params: { cbid, orgId },
  };
};

const transformPayloadForCloudflare = (payload: any) => {
  const { cbid, formValues } = payload;

  return {
    data: {
      connector: CONNECTOR_TYPES.CLOUDFLARE,
      provider: 'COWBELL',
      credentials: {
        ...formValues,
      },
      cbid,
      metadata: null,
    },
  };
};

const transformPayloadForLangfuse = (payload: any) => {
  const { cbid, formValues } = payload;

  return {
    data: {
      connector: CONNECTOR_TYPES.LANGFUSE,
      provider: 'COWBELL',
      credentials: {
        ...formValues,
      },
      cbid,
      metadata: null,
    },
  };
};

const transformPayloadForSophos = (payload: any) => {
  const { cbid, formValues } = payload;

  return {
    data: {
      connector: CONNECTOR_TYPES.SOPHOS,
      provider: 'COWBELL',
      credentials: {
        ...formValues,
      },
      cbid,
      metadata: null,
    },
  };
};

const transformPayloadForClaude = (payload: any) => {
  const { cbid, formValues } = payload;

  return {
    data: {
      connector: CONNECTOR_TYPES.CLAUDE,
      provider: 'COWBELL',
      credentials: {
        complianceAccessKey: formValues?.complianceAccessKey?.trim(),
      },
      cbid,
      metadata: null,
    },
  };
};
